import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const AdminEditTextMessage = () => {
  const [content, setContent] = useState('');
  const [scheduledDate, setScheduledDate] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  useEffect(() => {
    fetchTextMessage();
  }, [id]);

  const fetchTextMessage = async () => {
    try {
      const response = await axios.get(`/api/admin/text-messages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const { content, scheduledDate, status } = response.data;
      setContent(content);
      setScheduledDate(scheduledDate);
      setStatus(status);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching text message:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `/api/admin/text-messages/${id}`,
        { content, scheduledDate, status },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      navigate('/admin/text-messages');
    } catch (error) {
      console.error('Error updating text message:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8'>
      <h1 className='text-2xl font-bold mb-6'>Edit Text Message</h1>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className='mb-4'>
            <label className='block text-gray-700 mb-2'>Content</label>
            <textarea
              value={content}
              onChange={(e) => setContent(e.target.value)}
              className='w-full p-2 border rounded'
              required
            />
          </div>
          <div className='mb-4'>
            <label className='block text-gray-700 mb-2'>Scheduled Date</label>
            <input
              type='datetime-local'
              value={scheduledDate}
              onChange={(e) => setScheduledDate(e.target.value)}
              className='w-full p-2 border rounded'
              required
            />
          </div>
          <div className='mb-4'>
            <label className='block text-gray-700 mb-2'>Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className='w-full p-2 border rounded'
              required
            >
              <option value='scheduled'>Scheduled</option>
              <option value='sent'>Sent</option>
              <option value='failed'>Failed</option>
            </select>
          </div>
          <button
            type='submit'
            className='bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded'
          >
            Update Text Message
          </button>
        </form>
      )}
    </div>
  );
};

export default AdminEditTextMessage;
